import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import s from './Timeline.module.scss';

const Chapter = ({
  chapter,
  duration,
  hoverProgress,
  isHoveredChapter,
  playbackProgress,
  bufferedProgress,
}) => (
  <div
    className={s.chapterItemContainer}
    style={{
      left: `calc(${(chapter.startTime * 100) / (duration || 1)}%)`,
      width: `calc(${((chapter.endTime - chapter.startTime) * 100) / (duration || 1)}%)`,
    }}
  >
    <div
      className={cn(s.chapterItem, {
        [s.hoveredChapter]: isHoveredChapter,
        [s.chapterPlaying]: playbackProgress > 0 && playbackProgress < 1,
        [s.chapterBuffered]: bufferedProgress > 0,
      })}
    >
      <div
        className={s.chapterItemBufferedTrack}
        style={{
          transform: `scaleX(${bufferedProgress})`,
          transformOrigin: 'left center',
        }}
      />
      <div
        className={s.chapterItemPlaybackTrack}
        style={{
          transform: `scaleX(${playbackProgress})`,
          transformOrigin: 'left center',
        }}
      />

      <div
        className={s.chapterItemHoverTrack}
        style={{
          transform: `scaleX(${hoverProgress})`,
          transformOrigin: 'left center',
        }}
      />
    </div>
    <If condition={playbackProgress < 1 && playbackProgress > 0}>
      <div
        style={{
          left: `${playbackProgress * 100}%`,
        }}
        className={s.playPointMarker}
      />
    </If>
  </div>
);

Chapter.propTypes = {
  chapter: PropTypes.shape({
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
  }).isRequired,
  duration: PropTypes.number.isRequired,
  hoverProgress: PropTypes.number.isRequired,
  isHoveredChapter: PropTypes.bool.isRequired,
  playbackProgress: PropTypes.number.isRequired,
  bufferedProgress: PropTypes.number.isRequired,
};

export default Chapter;
